export default __webpack_public_path__ + "static/media/DinosaurSafari_00.09aa7b50.png";